export enum premiumType {
  STANDARD = "STANDARD",
  SPLIT = "SPLIT",
}
